import smoothscroll from 'smoothscroll-polyfill';
import { initialize } from 'store/create';
import { initializeGoogle } from 'utils/search/autocomplete';
import { saveGAClientId } from 'store/modules/user';
import Cookies from 'universal-cookie';

const initializeApp = ({ dispatch, getState }) => {
	const { app, user } = getState();

	if (globalThis.ga) {
		globalThis.ga((tracker) => {
			const clientId = tracker.get('clientId');
			if (clientId && clientId !== user.gcid) {
				dispatch(saveGAClientId(clientId));
				const cookies = new Cookies();
				cookies.set('gcid', clientId, { path: '/' });
			}
		});
	}

	initializeGoogle({
		key: app.googleMapsKey,
	});

	smoothscroll.polyfill();

	dispatch(initialize());
};

export default initializeApp;
